import { Action, Dispatch } from "@reduxjs/toolkit";
import { initMessageListener } from "redux-state-sync";
import { initializeSSRStore } from "../lib/redux/customStore";

export const store = initializeSSRStore();
initMessageListener(store);
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = Dispatch<Action<any>>;
